import useAppMenu from './useAppMenu';

export default useAppMenu;
